import React from 'react';

import autoBind from 'react-autobind';
import { If, Then } from 'react-if'
import Switch, { Case } from 'react-switch-case';
import copy from 'copy-to-clipboard';
import QRCodeSVG from 'qrcode.react';

// import other components within the same project here
import Config from "../../Config.jsx";

import Localization from "../../Localization.jsx"

import KLAList from "../../views/locale/KLAList.jsx"
import FilePickerCard from "../../views/FilePickerCard.jsx"

import {
  Grid,
  TextField,
  FormControl,
  FormHelperText,
  Select,
  MenuItem,
  Icon,
  Tooltip,
  InputAdornment,
} from '@material-ui/core';

const SECRET = "clst";
const LOCALE_ID_PREFIX = "evvr_id";

class LocaleDetailView extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      isDirty: false,
      activeView: 0,
      localeName: "",
      localeDesc: "",
      localeKLA: 0,
      localeCoverFileID: "",
      localeShareable: false,
      localePublish: false,
      localeManualPlay: false,
      localeLink: "",
    };
    autoBind(this);

    if (this.props.locale_name.length > 0) {
      this.state.localeName = this.props.locale_name;
    }
    if (this.props.description.length > 0) {
      this.state.localeDesc = this.props.description;
    }
    if (this.props.kla) {
      this.state.localeKLA = this.props.kla;
    }
    if (this.props.tn_file_id) {
      this.state.localeCoverFileID = this.props.tn_file_id;
    }
    if (this.props.activeView) {
      this.state.activeView = this.props.activeView
    }
    this.state.localeShareable = this.props.is_share > 0;
    this.state.localePublish = this.props.is_ready > 0;
    this.state.localeManualPlay = this.props.is_manual_play > 0;

    if (this.props.parent.props.localeData != null) {
      this.state.localeLink = "eduventure.vr://?";
      this.state.localeLink += "localeID_v2=" + this.cipher(this.props.parent.props.localeData.id, SECRET);

      let encrypted = this.cipher(this.props.parent.props.localeData.id, SECRET);
      let decrypted = this.decipher(encrypted, SECRET);
      console.log(encrypted, decrypted);
    }
  }

  cipher(id, secret) {
    let result = '';
    for(let i = 0; i < id.length; i++) {
        let xorResult = id.charCodeAt(i) ^ secret.charCodeAt(i % secret.length);
        result += xorResult.toString(16).padStart(2, '0');
    }
    return result;
  }

  decipher(encrypted, secret) {
    let result = '';
    for(let i = 0; i < encrypted.length; i += 2) {
        let charCode = parseInt(encrypted.substr(i, 2), 16);
        result += String.fromCharCode(charCode ^ secret.charCodeAt((i / 2) % secret.length));
    }
    return result;
  }

  changeActiveView(index) {
    this.setState({ activeView: index });
    this.state.activeView = index;
  }

  localeNameChanged(e) {
    this.setState({
      localeName: e.target.value
    });
    this.state.localeName = e.target.value;

    if (this.props.parent.state.title != null) {
      this.props.parent.setState({ title: this.state.localeName });
    }
  }

  localeDescChanged(e) {
    this.setState({
      localeDesc: e.target.value
    })
    this.state.localeDesc = e.target.value;
  }

  localeKLAChanged(e) {
    this.setState({localeKLA: e.target.value});
    this.state.localeKLA = e.target.value;

    this.setState({ localeSubject: 0 });
    this.state.localeSubject = 0;
  }

  localeShareableChanged(e) {
    this.setState({localeShareable: e.target.value});
    this.state.localeShareable = e.target.value;
  }

  localePublishChanged(e) {
    if (e.target.value == true) {
      let dialogText = {
        title: Localization.strings.CONFIRM_PUBLISH_MESSAGE,
        content: Localization.strings.VITALS_WILL_VISIBLE_MESSAGE,
      }
      this.props.root.refs.confirmDialog.show(dialogText, this.publicConfirmClicked, this.publicCancelClicked);
    }
    else {
      this.setState({localePublish: e.target.value});
      this.state.localePublish = e.target.value;
    }
  }

  publicConfirmClicked() {
    this.setState({localePublish: true});
    this.state.localePublish = true;
  }

  publicCancelClicked() {

  }

  localeManualPlayChanged(e) {
    this.setState({localeManualPlay: e.target.value});
    this.state.localeManualPlay = e.target.value;
  }

  validateInput() {
    let isValid = true;
    let errorMessage = "";
    switch (this.state.activeView) {
      case 0:
        let name = this.state.localeName.trim();
        this.setState({ localeName: name });
        this.state.localeName = name;
        if (name == "") {
          isValid = false;
          errorMessage = Localization.strings.LOCALE_NAME_BLANK_REMINDER;
        }
        else if (this.state.localeKLA <= 0) {
          isValid = false;
          errorMessage = Localization.strings.LOCALE_KLA_BLANK_REMINDER;
        }
        break;
      case 1:
        if (this.state.localeCoverFileID == "") {
          isValid = false;
          errorMessage = Localization.strings.LOCALE_COVER_BLANK_REMINDER;
        }
        break;
      case 2:
        break;
      default:
        break;
    }

    if (errorMessage != "") {
      this.props.root.addNotification(errorMessage);
    }

    return isValid;
  }

  onUploadSuccess(res) {
    let fileID = res['file_id'];
    this.setState({ localeCoverFileID: fileID });
    this.state.localeCoverFileID = fileID;

    if (this.props.parent.onUploadSuccess) {
      this.props.parent.onUploadSuccess();
    }
  }

  onAbortUpload() {
    this.setState({ localeCoverFileID: "" });
    this.state.localeCoverFileID = "";
  }

  onKLAChanged(e) {
    this.localeKLAChanged(e);
  }

  copyLocaleLinkClicked() {
    copy(this.state.localeLink);
    this.props.root.addNotification("Copied to clipboard");
  }

  render() {
    let localeDetails = (
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={8} sm={2}>
          {Localization.strings.NAME}
        </Grid>
        <Grid item xs={8} sm={10}>
          <TextField value={this.state.localeName} onChange={this.localeNameChanged}/>
        </Grid>
        <Grid item xs={8} sm={2}>
          {Localization.strings.DESCRIPTION}
        </Grid>
        <Grid item xs={8} sm={10}>
          <TextField value={this.state.localeDesc} onChange={this.localeDescChanged} multiline/>
        </Grid>
        <Grid item xs={8} sm={2}>
          {Localization.strings.KLA_SHORT}
        </Grid>
        <Grid item xs={8} sm={10}>
          <KLAList kla={this.state.localeKLA} root={this.props.root} parent={this} ref="klaList"/>
        </Grid>
      </Grid>
    );

    return (
      <div>
        <Switch condition={this.state.activeView}>
          <Case value={0}>
            {localeDetails}
          </Case>
          <Case value={1}>
            <Grid container spacing={2} alignItems="center" justify="center">
              <Grid item xs={12} sm={6}>
                <div>
                  <FilePickerCard parent={this} root={this.props.root} ref="filePickerCard"
                    kind={2}
                    localeId={this.props.root.state.targetLocaleData['id']}
                    allowedExtension={Config.GET_ALLOWED_FILE_EXTENSION("image")}
                    onUploadSuccess={this.onUploadSuccess}
                    file_id={this.state.localeCoverFileID}
                  />
                </div>
              </Grid>
            </Grid>
          </Case>
          <Case value={2}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={8} sm={2}>
                {Localization.strings.SHARABLE}
              </Grid>
              <Grid item xs={8} sm={10}>
                <FormControl>
                  <Select
                    value={this.state.localeShareable}
                    onChange={this.localeShareableChanged}
                  >
                    <MenuItem value={true}>{Localization.strings.PUBLIC}</MenuItem>
                    <MenuItem value={false}>{Localization.strings.PRIVATE}</MenuItem>
                  </Select>
                  <FormHelperText>{ this.state.localeShareable? "" : Localization.strings.VITALS_SHARABLE_MESSAGE }</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={8} sm={2}>
                {Localization.strings.PUBLISH}
              </Grid>
              <Grid item xs={8} sm={10}>
                <FormControl>
                  <Select
                    value={this.state.localePublish}
                    onChange={this.localePublishChanged}
                  >
                    <MenuItem value={true}>{Localization.strings.YES}</MenuItem>
                    <MenuItem value={false}>{Localization.strings.NO}</MenuItem>
                  </Select>
                  <FormHelperText>{ this.state.localePublish? Localization.strings.VITALS_VISIBLE_MESSAGE :  Localization.strings.VITALS_INVISIBLE_MESSAGE}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={8} sm={2}>
                {Localization.strings.MANUAL_START}
              </Grid>
              <Grid item xs={8} sm={10}>
                <FormControl>
                  <Select
                    value={this.state.localeManualPlay}
                    onChange={this.localeManualPlayChanged}
                  >
                    <MenuItem value={true}>{Localization.strings.YES}</MenuItem>
                    <MenuItem value={false}>{Localization.strings.NO}</MenuItem>
                  </Select>
                  <FormHelperText>{ this.state.localeManualPlay? Localization.strings.MANUAL_START_YES_MESSAGE : Localization.strings.MANUAL_START_NO_MESSAGE }</FormHelperText>
                </FormControl>
              </Grid>
              <If condition={this.state.localeLink.length != 0}>
                <Then>
                  <Grid item xs={8} sm={2}>
                    {Localization.strings.LINK}
                  </Grid>
                  <Grid item xs={8} sm={8}>
                    <TextField
                      value={this.state.localeLink}
                      fullWidth={true}
                      InputProps={{
                        readOnly: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <Tooltip
                              title={"Copy to clipboard"}
                              placement="bottom"
                            >
                              <Icon
                                onClick={this.copyLocaleLinkClicked}
                                style={{cursor:'pointer'}}
                              >
                                file_copy
                              </Icon>
                            </Tooltip>
                          </InputAdornment>
                        )
                      }}
                    />
                  </Grid>
                  <Grid item xs={8} sm={2}>
                  </Grid>
                  <Grid item xs={8} sm={2}>
                    {Localization.strings.QR_CODE}
                  </Grid>
                  <Grid item xs={8} sm={10}>
                    <QRCodeSVG
                      value={this.state.localeLink}
                      includeMargin={true}
                    />
                  </Grid>
                </Then>
              </If>
            </Grid>
          </Case>
        </Switch>
      </div>
    )
  }
}

export default LocaleDetailView;
